<template>
  <div class="winners-list">
    <p class="winners-badge"><img src="//res.aidalan.com/hd/sg/img/badge.png"></p>
    <div class="winners-content">
      <h2>获奖名单</h2>
      <div class="winners-info">
        <div class="winners-info2" :style="{animation: animationCss}">
          <div>
            <p v-for="(item, index) in winnersList"
            :key="index"><span>{{item.username}}</span>{{item.goods_name}}</p>
          </div>
          <div>
            <p v-for="(item, index) in winnersList"
            :key="index"><span>{{item.username}}</span>{{item.goods_name}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      winnersList: [],
      animationCss: '',
    };
  },
  created() {
    this.winnersInfo();
  },
  updated() {
    this.$nextTick(() => {
      const o = document.querySelector('.winners-info2');
      const t = ((o.offsetHeight * 10) / 360).toFixed(3);
      this.animationCss = `scroll ${t}s linear infinite`;
    });
  },
  methods: {
    async winnersInfo() {
      const res = await axios.post('/api/allWinRecord', {
        f_id: 1,
      });
      if (res.data.ret === 1) {
        this.winnersList = res.data.content;
      }
    },
  },
};
</script>

<style>
.winners-list{
  padding: 4% 3.125% 2%;
  background-color: #f2eaea;
}
ul{
  margin: 0;
  list-style: none;
}
.winners-badge{
  float: left;
  width: 18.3333%;
  padding: 1% 0;
}
.winners-badge img{
  display: block;
  width: 89.9082%;
  margin: 0 auto;
}
.winners-content{
  width: 81.6667%;
  float: left;
}
.winners-content .winners-info{
  padding: 0 2%;
  margin: 1% 0;
  border: 1px solid #6c6c6c;
  height: 6em;
  overflow: hidden;
}
.winners-content h2{
  color: #ad1e1a;
}
.winners-list, .winners-content h2{
  font-size: 3vw;
}
@media (min-width: 640px) {
  .winners-list, .winners-content h2{
    font-size: 20px;
  }
}
.winners-info2>div::after, .winners-list::after{
  content: "";
  display: block;
  clear: both;
}
.winners-info p{
  float: left;
  width: 50%;
  color: #342424;
  line-height: 2em;
}
.winners-info p span{
  display: inline-block;
  min-width: 3.6em;
  margin-right: .2em;
}
.winners-info2{
  transform: translateY(0);
}
@keyframes scroll {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Winners.vue